import React, { useEffect, useRef, useState } from 'react';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { connect } from 'react-redux';
import Functions from '../../api/Functions';
import { notificationsType } from '../../constants/constants';
import Loading from '../generalComponets/Loading';
import SelectUsers from '../questions/SelectUsers';
import { Redirect } from 'react-router-dom';
import SelectCompany from '../generalComponets/SelectCompany';
import CustomCheckbox from '../generalComponets/CustomCheckbox';
import CustomInput from '../generalComponets/CustomInput';
import CustomTextArea from '../generalComponets/CustomTextArea';
import ValidationMessage from '../generalComponets/ValidationMessage';
import SelectDate from '../generalComponets/SelectDate';
import firebase from 'firebase';

function Notifications(props) {
  const [imageUrl, setImageUrl] = useState('');
  const [customImage, setCustomImage] = useState(false);
  const [pushNotification, setPushNotification] = useState(false);
  const [link, setLink] = useState('');
  const [addLink, setAddLink] = useState(false);
  const [title, setTitle] = useState('');
  const [smallTitle, setSmallTitle] = useState('');
  const [message, setMessage] = useState('');
  const [smallMessage, setSmallMessage] = useState('');
  const [showSmallText, setShowSmallText] = useState(false);
  const [addCompany, setAddCompany] = useState(false);
  const [scheduleForLater, setScheduleForLater] = useState(false);
  const [validTitle, setValidTitle] = useState(true);
  const [validSmallTitle, setValidSmallTitle] = useState(true);
  const [validMessage, setValidMessage] = useState(true);
  const [validSmallMessage, setValidSmallMessage] = useState(true);
  const [validUsers, setValidUsers] = useState(true);
  const [validCompany, setValidCompany] = useState(true);
  const [showProcess, setShowProcess] = useState(false);
  const selectCompanyRef = useRef();
  const datePickerRef = useRef();
  const childRef = useRef();

  useEffect(() => {
    if (!showSmallText) {
      setSmallTitle('');
      setSmallMessage('');
    }
  }, [showSmallText]);

  useEffect(() => {
    if (!addLink) {
      setLink('');
    }
  }, [addLink])

  useEffect(() => {
    if (!customImage) {
      setImageUrl('');
    }
  }, [customImage]);

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const validFields = () => {
    const profiles = childRef?.current.getProfiles();
    const companyId = selectCompanyRef.current ? selectCompanyRef?.current.getCompany() : null;
    const validMessage = message.length > 0;
    const validTitle = title.length > 0;
    const validProfiles = profiles && profiles.length > 0;
    const validSmallTitle = showSmallText ? smallTitle.length > 0 : true;
    const validSmallMessage = showSmallText ? smallMessage.length > 0 : true;
    const validCompany = addCompany ? companyId != null : true;
    setValidMessage(validMessage);
    setValidTitle(validTitle);
    setValidUsers(validProfiles);
    setValidSmallTitle(validSmallTitle);
    setValidSmallMessage(validSmallMessage);
    setValidCompany(validCompany);
    return validMessage && setValidTitle && validProfiles && validSmallTitle && validSmallMessage && validCompany;
  };

  const sendNotification = async () => {
    if (validFields()) {
      setShowProcess(true);
      try {
        let templateId = await createTemplate();
        if (!scheduleForLater) {
          await sendNotifications(templateId);
        } else {
          await createScheduleMessage(templateId);
        }
        setShowProcess(false);
      } catch (e) {
        console.log(e.message);
        setShowProcess(false);
      }
    }
  };

  const createTemplate = async () => {
    const profiles = childRef?.current.getProfiles();
    const profileIds = profiles.map((p) => p.id);
    const scope = childRef?.current.getScope();
    const company = selectCompanyRef.current ? selectCompanyRef?.current.getCompany() : null;
    const country = childRef?.current.getCountry();
    const state = childRef?.current.getState();
    const response = await Functions.createMessageTemplate({
      title,
      message,
      smallTitle,
      smallMessage,
      link,
      pushNotification,
      scope,
      profileIds,
      imageUrl,
      bannerUrl: company ? company.bannerUrl : null,
      companyId: company ? company.id : null,
      country,
      state,
    });
    return response.data;
  };

  const createScheduleMessage = async (templateId) => {
    const date = datePickerRef?.current.getFullDate();
    const scheduleDate = firebase.firestore.Timestamp.fromMillis(Date.parse(`${date.date.toString()}`));
    await Functions.scheduleNewMessage({
      templateId,
      scheduleDate,
      stringDate: date.date.toString(),
      send: false,
      timezone: date.timezone,
      offset: date.offset,
      hour: date.hour,
    });
  };

  const sendNotifications = async (templateId) => {
    const profiles = childRef?.current.getProfiles();
    const profileIds = profiles.map((p) => p.id);
    const notification = {
      templateId: templateId,
      title: title,
      smallTitle: smallTitle,
      message: message,
      smallMessage: smallMessage,
      link: link,
      reviewed: false,
      image: '',
      type: notificationsType.CUSTOM,
    };
    await Functions.sendCustomNotification(profileIds, notification, pushNotification, imageUrl);
  };

  const changeAddCompany = (value) => {
    setAddCompany(value);
    if (value) {
      childRef?.current.changeToCountryOption();
    }
  };

  const renderValidations = () => (
    <div>
      <ValidationMessage isValid={!validTitle} text={'Enter Title'} />
      <ValidationMessage isValid={showSmallText && !validSmallTitle} text={'Enter Small Title'} />
      <ValidationMessage isValid={!validMessage} text={'Enter message'} />
      <ValidationMessage isValid={showSmallText && !validSmallMessage} text={'Enter Small message'} />
      <ValidationMessage isValid={!validUsers} text={'Select Users'} />
      <ValidationMessage isValid={!validCompany} text={'Select Company'} />
    </div>
  );

  const renderInputs = () => (
    <div>
      <CustomInput id="url" label="Image Url" value={imageUrl} setValue={setImageUrl} hide={!customImage} />
      <CustomInput id="link" label="Link" value={link} setValue={setLink} hide={!addLink} />
      <CustomInput id="title" label="Title" value={title} setValue={setTitle} />
      <CustomInput
        id="smallTitle"
        label="Small Title"
        value={smallTitle}
        setValue={setSmallTitle}
        hide={!showSmallText}
      />
      <CustomTextArea id="message" label="Message" value={message} setValue={setMessage} />
      <CustomTextArea
        id="smallMessage"
        label="Small Message"
        value={smallMessage}
        setValue={setSmallMessage}
        hide={!showSmallText}
      />
    </div>
  );

  return (
    <div className="container">
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="col s6">
          <h5>Notification</h5>
          <CustomCheckbox text="Push Notification" value={pushNotification} setValue={setPushNotification} />
          <CustomCheckbox text="Custom Image" value={customImage} setValue={setCustomImage} />
          <CustomCheckbox text="Add Link" value={addLink} setValue={setAddLink} />
          <CustomCheckbox text="Small Text" value={showSmallText} setValue={setShowSmallText} />
          <CustomCheckbox text="Add Company" value={addCompany} setValue={changeAddCompany} />
          <CustomCheckbox text="Schedule forLater" value={scheduleForLater} setValue={setScheduleForLater} />
          {renderInputs()}
          {!addCompany ? <div /> : <SelectCompany ref={selectCompanyRef} country={childRef?.current.getCountry()} />}
          {!scheduleForLater ? <div /> : <SelectDate withTimezone={true} ref={datePickerRef} />}
          <button className="btn" onClick={sendNotification}>
            Send Notification
          </button>
          {renderValidations()}
        </div>
        <div className="col s6">
          <h5>Send to</h5>
          <SelectUsers ref={childRef} showQuestionStatus={true} propagateOptionAll={() => setAddCompany(false)} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([]), connect(mapStateToProps))(Notifications);
